import { RepeatingTaskB50 } from './RepeatingTaskB50';
import { RepeatingTaskCV50 } from './RepeatingTaskCV50';

interface RepeatingTaskProps {
  isB50: boolean;
}

export const RepeatingTask = ({ isB50 }: RepeatingTaskProps): JSX.Element =>
  isB50 ? <RepeatingTaskB50 /> : <RepeatingTaskCV50 />;
